import React from "react"
import { Link, graphql } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"
import AuthorContent from "../../components/author-content"

import _ from 'lodash'
import ogImage from "../../images/posts/31/thumb-landscape.jpg"

const Post31 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>多くの方がイメージするCHANEL／シャネルのバッグといえば、このクラシック ハンドバッグ。<br></br>カール ラガーフェルドが生んだ名品です。今回は、年齢を問わず世界中の女性に愛され続けるシャネルの魅力に迫ります。<br></br>クラシック ハンドバッグを使ったコーデやこのバッグが誕生するまでの経緯などをたっぷりお届け。人気の秘密を紐解いていきます。</p>
        </div>
      </div>
    </section>
    <div className="wrapper">
      <section className="bag-content">
        <div className="text-two-cloumn">
          <h2>4通りのシャネルの愛し方</h2>
          <p>様々なコーデが楽しめるシャネルのクラシック ハンドバッグ。チェーンバッグやマトラッセとも呼ばれています。<br></br>エレガントなイメージのこのバッグ。あなたなら、どんなお洋服と合わせますか？<br></br>4人の方に登場してもらい、それぞれのスタイリングを披露してもらいます！</p>
        </div>
        <div className="text-max-width">
          <h2>モード好きのキレイめ大人コーデ</h2>
          <figure>
            <StaticImage src="../../images/posts/31/1.jpg" alt="" />
            <span className="text-center">身長：153 cm</span>
          </figure>          
          <p>ブラックコーデでまとめたERIさん。シャネルのバッグ、ミニスカートやハイヒールなど女性らしいアイテムばかりですが、トータルでかっこいい…、そんな大人の余裕を感じます。</p>
          <figure>
            <StaticImage src="../../images/posts/31/2.jpg" alt="" />
          </figure>
        </div>        
        <div className="text-max-width">
          <h2>コーデのポイント</h2>
          <p><span style={{fontWeight: 'bold', color: '#B67C29'}}>ERIさん：</span>今日のお気に入りアイテムは、YOKO CHANのミニスカートとルブタンのハイヒール。モード好きな私ですが、いつもより上品になるように意識しました。シャネルを持つときは「ちょぴり上品に」そんな気持ちになるから不思議。シャネルのパワーですね（笑）</p>
        </div>
        <Link to="https://laxus.co/app/pc/bags/chanel" className="view-all-button">
          シャネルのバッグを見る
        </Link>                
        <div className="text-max-width">
          <h2>トラディショナルなスタイルにパリの風</h2>
          <figure>
            <StaticImage src="../../images/posts/31/3.jpg" alt="" />
            <span className="text-center">身長：160 cm</span>
          </figure>          
          <p>makoさんは、ステンカラーのコートにチェックのスカート、足元はローファーとブリティッシュ・トラディショナルなコーデ。そこにシャネルのバッグをプラスするだけで、パリの空気感が漂います。</p>
          <figure>
            <StaticImage src="../../images/posts/31/4.jpg" alt="" />
          </figure>
        </div>
        <div className="text-max-width">
          <h2>コーデのポイント</h2>
          <p><span style={{fontWeight: 'bold', color: '#B67C29'}}>makoさん（以下、mako）：</span>“シャネル”というと、エレガントで大人っぽいイメージですが、自分らしいスタイルで持ってみました。<br></br>意外なほど違和感がなくてビックリ（笑）ハイヒールじゃなくても、いけます！ボーイッシュなスタイルでも挑戦してみたいです。</p>
          <figure>
            <StaticImage src="../../images/posts/31/4-2.jpg" alt="" />
          </figure>
          <p><span style={{fontWeight: 'bold', color: '#B67C29'}}>mako：</span>実際に手にして思ったのは、想像より「大きい」でした。雑誌やSNSなどで何度も目にしたことはありましたが、持ってみないとわからないことってあるなぁって感じました。</p>
        </div>
        <div className="text-max-width">
          <h2>トレンドコーデのポイントに名品バッグ</h2>
          <figure>
            <StaticImage src="../../images/posts/31/5.jpg" alt="" />
            <span className="text-center">身長：161 cm</span>
          </figure>          
          <p>チェックのダブルのJKにヴィーガンレザーのパンツという、今年らしいスタイリングをしてくれたMANAさん。トレンドコーデにもしっくりきちゃう、シャネルの底力を見たりといったところです。</p>
          <figure>
            <StaticImage src="../../images/posts/31/6.jpg" alt="" />
          </figure>
        </div>
        <div className="text-max-width">
          <h2>コーデのポイント</h2>
          <p><span style={{fontWeight: 'bold', color: '#B67C29'}}>MANAさん（以下、MANA）：</span>バッグの黒が目立つように、ベースカラーはベージュにしました。チェックのジャケットがつなぎになって、いい感じにまとまったかな？（笑）</p>
          <figure>
            <StaticImage src="../../images/posts/31/7.jpg" alt="" />
          </figure>
          <p><span style={{fontWeight: 'bold', color: '#B67C29'}}>MANA：</span>ジャケットとパンツのスタイルですが、シャネルのバッグがちゃんと女の子に呼び戻してくれる…そんな気がします。メンズライクなアイテムやカジュアルなスタイルにこそ、合わせてみると面白いかも。</p>
        </div>
        <Link to="https://laxus.co/app/pc/bags/chanel" className="view-all-button">
          シャネルのバッグを見る
        </Link>        
        <div className="text-max-width">
          <h2>気分はレトロガール</h2>
          <p>大人っぽい女性のイメージを抱きがちなシャネルのチェーンバッグに、オレンジ×ホワイト×パープルのビビットカラー！ベルト、シューズ、バッグの3点をブラックにしたことで、違和感なくまとまっています。jawaさんにコーデのポイントを聞いてみました。</p>
          <figure>
            <StaticImage src="../../images/posts/31/8.jpg" alt="" />
            <span className="text-center">身長：160 cm</span>
          </figure>          
          <p><span style={{fontWeight: 'bold', color: '#B67C29'}}>jawaさん（以下、jawa）：</span>テーマはレトロです！ブラウスの大きな襟やギンガムの柄で、昔の映画に出てくるウェイトレスみたいな雰囲気をイメージしてみました。</p>
          <figure>
            <StaticImage src="../../images/posts/31/9.jpg" alt="" />
          </figure>
          <p><span style={{fontWeight: 'bold', color: '#B67C29'}}>jawa：</span>ラクサスのバッグって、新品ではないですよね。私はそこが気に入っています。特にこのシャネルのチェーンバッグのような定番って、ちょっと使用感がある方が、かっこいいと思うんですよね。こなれた感じっていうか（笑）</p>
          <figure>
            <StaticImage src="../../images/posts/31/10.jpg" alt="" />
          </figure>
          <p><span style={{fontWeight: 'bold', color: '#B67C29'}}>jawa：</span>色で遊ぶのが大好きです。今日は明るめですが、くすんだカラーもよく着ます。洋服で遊んで、バッグとかの小物でまとめるのが私の定番です。</p>                    
        </div>
        <Link to="https://laxus.co/app/pc/bags/chanel" className="view-all-button">
          シャネルのバッグを見る
        </Link>            
        <div className="text-max-width">
          <h2>長財布は入る？</h2>
          <figure>
            <StaticImage src="../../images/posts/31/11.jpg" alt="" />
          </figure>
          <p>小さめバッグは可愛いけれど、荷物がちゃんと入るのかも気になるところ。長財布とカードケースを入れてみました！うん！ちゃんと収まります。</p>
          <figure>
            <StaticImage src="../../images/posts/31/12.jpg" alt="" />
          </figure>
          <p>オープンするとドーンっと出てくるシャネルマークにテンションが上ります！</p>
          <figure>
            <StaticImage src="../../images/posts/31/13.jpg" alt="" />
          </figure>
          <p>横幅はこんな感じ。長財布を入れてもサイドに若干ゆとりありです。背面にはポケットがふたつ。全面には大きなポケットがひとつ。細かいものの収納に便利そう！</p>                    
        </div>
        <div className="text-max-width">
          <h2>オリジナル「2.55」を超えた！？名作「クラシック」</h2>
          <p>クラシックは「11.12」との呼び名もあります。ココ・シャネルの生んだ伝説のアイコンバッグ「2.55」がオリジナルだとか。<br></br>1983年にシャネルのアーティスティック ディレクター就任したカール・ラガーフェルドが「2.55」再解釈することで誕生しました。</p>
        </div>
        <div className="text-max-width">
          <h2>シャネルのアイコンバッグ「2.55」とは？</h2>
          <figure className="img-small">
            <StaticImage src="../../images/posts/31/14.jpg" alt="" />
            <span className="text-center">25x16x7cm</span>
          </figure>
          <p>この今では当たり前であるバッグのチェーンは、ココ・シャネルが生んだ「2.55」が始まり。それまで、装飾などのデザイン面しか重要視されていなかったクラッチバッグとは違い、両手が自由に使えるようにとショルダーストラップをつけたのがココ・シャネルです。<br></br>当時、世間からは反抗的で下品といった声もあったようですが、多くの女性達はその実用性に魅了されていきました。</p>
        </div>
        <div className="text-max-width">
          <h2>クラシック</h2>
          <figure className="img-small">
            <StaticImage src="../../images/posts/31/15.jpg" alt="" />
            <span className="text-center">25x16x7cm</span>
          </figure>
          <p>そして、こちらが「クラシック」。<br></br>一番の違いはフラップとボディを留める金具です。オリジナルでは端正なラインのマドモアゼルが、クラシックではCHANEL／シャネルと一目瞭然のCCロゴをあしらったものにアップデートされました。<br></br>また、ストラップの素材がオリジナルはチェーンのみ。クラシックはチェーンとブラックレザーのコンビです。<br></br>チェーンストラップは3WAY。シングルでクロスボディや肩掛けにしたり、ダブルで持ち手を短くしたり、チェーンをバッグに収納してクラッチ持ちもできます。</p>
        </div>                       
        <div className="text-two-cloumn">
          <h2>懐の深いシャネルのバッグ</h2>
          <p>名品といわれるアイテムは数多くありますが、手に取るとその理由がよくわかります。デザインの素晴らしさだけでなく、ちゃんと使いやすいのです。今回は定番のブラックのラムスキンタイプをご紹介しましたが、様々な素材や色で展開されています。とっかえひっかえバッグを交換できるラクサスなら、気軽にチャレンジできるはず。新しい自分に出会うチャンスです。</p>
        </div>        
        <Link to="https://laxus.co/app/pc/bags/chanel" className="view-all-button">
          シャネルのバッグを見る
        </Link>
      </section>
      <AuthorContent authorId={postsJson.authorId} />
    </div>
  </div>
</Layout>
)}

export default Post31

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 31}) {
      id
      title
      description
      postId
      postedAt
      description
      categoryId
      authorId
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
